import { useCopilotChat, useThreads } from '@copilotkit/react-core';
import { HeaderProps, useChatContext } from '@copilotkit/react-ui';
import { TooltipHost } from '@fluentui/react';
import { ChatAdd20Regular, Dismiss20Regular, Sparkle28Filled } from '@fluentui/react-icons';
import React from 'react';
import localeService from 'src/dataServices/LocaleService';

export const CustomCopilotHeader: React.FC<HeaderProps> = () => {
  const { setOpen, labels } = useChatContext();
  const { reset } = useCopilotChat();
  const { setThreadId } = useThreads();

  const handleNewConversation = () => {
    reset();
    setThreadId(crypto.randomUUID());
  };

  return (
    <div className="copilot-custom-header">
      <div className="copilot-custom-header-title">
        <div className="copilot-custom-header-icon-container">
          <Sparkle28Filled className="copilot-custom-header-icon" />
        </div>
        <span>{labels.title}</span>
      </div>
      <div className="copilot-custom-header-actions">
        <TooltipHost content={localeService.getText('ContactUs', 'CustomCopilotHeaderNewChatTooltip')}>
          <button
            className="copilot-custom-header-new-chat"
            onClick={handleNewConversation}
            aria-label={localeService.getText('ContactUs', 'CustomCopilotHeaderNewChatAriaLabel')}
          >
            <ChatAdd20Regular />
          </button>
        </TooltipHost>
        <TooltipHost content={localeService.getText('ContactUs', 'CustomCopilotHeaderCloseTooltip')}>
          <button className="copilot-custom-header-close" onClick={() => setOpen(false)} aria-label={localeService.getText('ContactUs', 'CustomCopilotHeaderCloseAriaLabel')}>
            <Dismiss20Regular />
          </button>
        </TooltipHost>
      </div>
    </div>
  );
};
